<template>
  <gj-modal
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>添加品类</template>
    <template #content>
<!--      <p>{{parentId | json}}</p>-->
      <el-form
          ref="form"
          :model="form"
          label-width="80px">
        <el-form-item
            label="品类名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入品类名称', trigger: ['blur', 'change'] },
              { max: 60, message: '长度不能大于60个字符', trigger: ['blur', 'change'] }
            ]">
          <gj-input
              v-model="form.name"
              class="form-input"
              width="100%"
          ></gj-input>
        </el-form-item>
        <el-form-item
            label="所属上级"
            prop="parentId">
          <gj-tree-select
              v-model="form.parentId"
              :data="productCategoryStore.tree"
              class="form-input"
              :clearable="true"
              width="100%"
          ></gj-tree-select>
        </el-form-item>
        <el-form-item
            label="描述"
            style="margin-bottom: 0;"
            prop="desc">
          <gj-textarea
              v-model="form.desc"
              :styles="{height: '120px', width: '100%'}"
              class="form-input">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {productCategoryStore} from "../store";
  import {defaultVal} from "../../../../../utils/common";
  import {addProductCategory} from "../../../../../api/product";

  export default {
    name: "app-product-category-add-modal",
    mixins: [modalMixIn],
    props: {
      parentId: {
        type: Number
      }
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          name: null,
          parentId: this.parentId,
          desc: null,
        },
        productCategoryStore: productCategoryStore,
      }
    },
    created() {
      this.form.parentId = this.parentId;
    },
    methods: {
      confirm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.confirmLoading = true;
            addProductCategory({
              pid: this.form.parentId,
              name: this.form.name,
              memo: defaultVal(this.form.desc, null),
            })
              .then(() => {
                this.$emit('created');
                this.$gjDestroy();
              })
              .complete(() => this.confirmLoading = false);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
